<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useCartStore } from '../../stores/cart';
import CartLineItems from '../CartLineItems.vue';
import CartTotals from '../CartTotals.vue';

const props = withDefaults(defineProps<{
    showShoppingCart?: boolean;
}>(), {
    showShoppingCart: true,
});

const { t } = useI18n({ useScope: 'global' });
const cart = useCartStore();
</script>

<template>
    <aside class="order-summary">
        <div v-if="cart.cart === null && cart.errors === null" class="order-summary__loading">
            {{ t('cart.loading') }}
        </div>

        <template v-else-if="(cart.cart?.lineItems ?? []).length > 0">
            <CartTotals />

            <div v-if="showShoppingCart">
                <h3>{{ t('checkout.shoppingCart') }}</h3>
                <CartLineItems />
            </div>
        </template>

        <p v-else class="order-summary__empty">{{ t('cart.empty') }}</p>
    </aside>
</template>
